// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lGL_h","titleWrap":"styles_titleWrap__BG3Hz","title":"styles_title__XK6qi","info":"styles_info__Y_w_s","redirectWrap":"styles_redirectWrap__VjS8j"};
module.exports.__checksum = "7a13646725f3"
